import React from 'react'
import './EditUnitMixTable.scss'
import PropTypes from 'prop-types'
import { formatNumber } from '@engine/utils/format'
import { EditUnitMixRow } from '@components/common'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import { move } from 'ramda'
import DeleteIcon from '@material-ui/icons/Delete'
import {
  Checkbox,
  Button
} from '@material-ui/core'
import { normalize } from '@engine/dependencies'

export class EditUnitMixTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      localComparableData: props.comparableData,
      checked: false,
      dragIndex: -1,
      reset: false,
      selectedRows: [],
      isLastRec: props.comparableData?.length === 2
    }
  }

  onDragOver = () => e => {
    e.preventDefault()
  }

  onDragStart = originalIndex => () => {
    this.setState({
      dragIndex: originalIndex
    })
  }

  onDrop = orderIndex => e => {
    e.preventDefault()
    if (orderIndex === this.state.dragIndex) {
      return
    }
    const rearrangedCData = move(this.state.dragIndex, orderIndex, this.state.localComparableData)
    this.setState({
      ...this.state,
      reset: true,
      localComparableData: [...normalize.calculateWtdAvgRowForUnitMix(rearrangedCData, this.props.unitMixCount)]
    })
  }

  handleChange = event => {
    let selectAllRows = []
    if (event.target.checked) {
      selectAllRows = Array.from(Array(this.state.localComparableData.length - 1).keys())
    } else {
      selectAllRows = []
    }
    this.setState({
      checked: event.target.checked,
      selectedRows: selectAllRows,
      reset: true
    })
  }

  handleRowSelection = selectedRowIndex => {
    let selected = [...this.state.selectedRows]
    if (selected.includes(Number(selectedRowIndex))) {
      selected = selected.filter(row => row !== Number(selectedRowIndex))
    } else {
      selected.push(Number(selectedRowIndex))
    }
    const allSelection = this.state.localComparableData.length - 1 === selected.length
    this.setState({
      ...this.state,
      selectedRows: [...selected],
      reset: true,
      checked: allSelection
    })
  }

  handleReset = () => {
    const cdata = this.props.comparableData
    this.setState({
      ...this.state,
      reset: false,
      localComparableData: [...this.props.comparableData],
      selectedRows: [],
      checked: false,
      isLastRec: cdata.length === 2
    })
  }

  handleDeleteSelected = () => {
    let cdata = this.state.localComparableData
    cdata = cdata.filter((data, index) => !this.state.selectedRows.includes(index))
    this.setState({
      ...this.state,
      reset: true,
      checked: false,
      localComparableData: [...normalize.calculateWtdAvgRowForUnitMix(cdata, this.props.unitMixCount)],
      selectedRows: [],
      isLastRec: cdata.length === 2
    })
  }

  handleDeleteRow = rowNum => {
    let cdata = this.state.localComparableData
    cdata = cdata.filter((data, index) => index !== rowNum)
    this.setState({
      reset: true,
      localComparableData: [...normalize.calculateWtdAvgRowForUnitMix(cdata, this.props.unitMixCount)],
      isLastRec: cdata.length === 2
    })
  }

  savePropertyDetails = () => {
    this.props.editUnitMixData({ comparableData: this.state.localComparableData, propertyType: this.props.propertyType })
    this.props.closeEditPopup()
  }

  render() {
    const { localComparableData } = this.state
    const { unitMixTableColumns, unitMixCount } = this.props
    const unitmix_attr_to_be_displayed = unitMixTableColumns?.filter(prop => prop.value !== 'NA').map(prop => prop.value)
    const totalRow = { ...localComparableData[localComparableData.length - 1] }

    return (
      <>
        <div className="unitmix-table-container" data-testid="unitmix-table-container">
          <div className="edit-unit-mix-table">
            <div className="edit-unit-mix-headers">
              <div className="global-checkbox">
                <Checkbox
                  checked={this.state.checked}
                  onChange={this.handleChange}
                  color="primary"
                  inputProps={{ 'aria-label': 'secondary checkbox', 'data-testid': 'unitmix-row-all' }}
                />
              </div>
              {unitMixTableColumns.map((obj, index) => (
                obj.key !== 'NA' ? <div key={index} className="header-text">{obj.key}</div> : null
              ))}
            </div>
            <div className="unite-mix-table-rows">
              {localComparableData && localComparableData.slice(0, localComparableData.length - 1).map((row, index) => (
                <EditUnitMixRow
                  handleRowSelection={this.handleRowSelection}
                  selectedRows={this.state.selectedRows}
                  key={index}
                  row={row}
                  index={index}
                  onDragOver={this.onDragOver}
                  onDragStart={this.onDragStart}
                  onDrop={this.onDrop}
                  comparableData={localComparableData}
                  unitMixCount={unitMixCount}
                  unitmix_attr_to_be_displayed={unitmix_attr_to_be_displayed}
                  onDelete={this.handleDeleteRow}
                  isLastRec={this.state.isLastRec}
                />))}
            </div>
            <div className="total-sticky">
              <div className="hidden-div"></div>
              {unitmix_attr_to_be_displayed.map((key, idx) => (
                <div key={idx} className="data-text">{formatNumber(key, totalRow[key])}</div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <div className="rows-count">
            <div className="count-info">{this.state.selectedRows.length}/{localComparableData.length - 1} rows
            {this.state.selectedRows.length === this.state.localComparableData.length - 1 &&
                <span className="warning_txt">Atleast one rows should be present in the unit mix.</span>}
            </div>
            <small className="detail-info">* First {unitMixCount} rows will be considered for Weighted Avg.</small>
          </div>
          <div className="btn-boxes">
            <Button className="btn cancel" data-testid="unitMixDetails-reset" id="unitMixDetails-reset" variant="contained" size="large" onClick={this.handleReset} disabled={!this.state.reset}>
              <span className="reset">Reset</span>
            </Button>
            <Button className="btn delete-selected" variant="contained" size="large" data-testid="unitmix-delete-selected"
            onClick={this.handleDeleteSelected}
            disabled={this.state.selectedRows.length === this.state.localComparableData.length - 1 || this.state.selectedRows.length === 0}>
              <div className="delete">
                <DeleteIcon className="delete-icon" />
                <div>Delete Selected</div>
              </div>
            </Button>
            <Button className="btn done" data-testid="unitMixDetails-done" id="unitMixDetails-done" variant="contained" size="large" onClick={this.savePropertyDetails}>
              <span className="tick"><img src="/images/btn_done.svg" /></span>
              <span className="done">Done</span>
            </Button>
          </div>
        </div>
      </>
    )
  }
}

EditUnitMixTable.propTypes = {
  propertyType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  unitMixTableColumns: PropTypes.array,
  comparableData: PropTypes.array,
  unitMixCount: PropTypes.number,
  editUnitMixData: PropTypes.func,
  closeEditPopup: PropTypes.func
}

const mapDispatchToProps = {
  editUnitMixData: Comps.actions.editUnitMixData
}

export default connect(
  null,
  mapDispatchToProps
)(EditUnitMixTable)
